module.exports = __webpack_public_path__ + "static/media/undraw_server_down_s4lk.3098f2c4.svg";